import * as React from 'react';
import Div from "@jumbo/shared/Div";
import {Typography} from "@mui/material";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import IconButton from '@mui/material/IconButton';

const MobileHeader = ({headerTx, backIcon, backOnClick, headerTxSize = 22, titleContainerStyle}) => {
    
    return (
        <Div sx={{
            display: 'flex',
            flexDirection: 'row',
            height: 64,
            backgroundColor: "#C21B17",
            position: 'fixed',
            top: 0,
            width: '100%',
            left: 0,
            zIndex: 999
        }}>
            {backIcon &&
                <Div 
                onClick={backOnClick}
                sx={{
                    minWidth: 64,
                    height: 64,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <IconButton sx={{
                        height: 24,
                        width: 24,
                        borderRadius: 100,
                        backgroundColor: "#FFFFFF",

                        '&:hover': {
                            backgroundColor: '#FFFFFF'
                        }
                    }}>
                        <NavigateBeforeIcon sx={{color: "#C21B17"}} />
                    </IconButton>
                </Div>
            }
            <Div sx={{
                height: 64,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                paddingRight: '64px',
                overflow: 'hidden',
                ... titleContainerStyle
            }}>
                <Typography fontSize={headerTxSize} fontWeight={600} 
                    sx={{
                        margin: 0, textAlign: 'center', color: "#ffffff", textOverflow: 'ellipsis', whiteSpace:'nowrap', overflow: 'hidden'}}
                >{headerTx}</Typography>
            </Div>
        </Div>
    );
};

export default MobileHeader;